import { Entity } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';

interface AssetProtectionGoalImpactProps {
    id: string;
    assetId: string;
    protectionGoalId: string;
    impactId?: string;
}

export class AssetProtectionGoalImpact extends Entity {
    assetId: string;
    protectionGoalId: string;
    impactId?: string;

    constructor({
        id,
        assetId,
        impactId,
        protectionGoalId,
    }: AssetProtectionGoalImpactProps) {
        super({ id });
        this.assetId = assetId;
        this.protectionGoalId = protectionGoalId;
        this.impactId = impactId;
    }

    static new({
        assetId,
        protectionGoalId,
        impactId,
    }: Omit<AssetProtectionGoalImpactProps, 'id'>): AssetProtectionGoalImpact {
        const uuid = new UUID();
        return new AssetProtectionGoalImpact({
            id: uuid.toString(),
            assetId,
            protectionGoalId,
            impactId,
        });
    }
}
